var EditorialCarousel = require('./_socialEditorialCarousel');
var { setSocialVideo } = require('./_socialVideo');

function observeCarousel({ carouselId, callback1 }) {
    console.log(">...........", carouselId);
    const $targetElement = document.getElementById(carouselId);
    if (!$targetElement) {
        console.error(`Element with ID "${carouselId}" not found.`);
        return;
    }

    let $carousel = null;
    const $targetVideos = document.querySelectorAll(`#videos video`);

    function handleCarouselInit(entries, observer) {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                const ratio = entry.intersectionRatio;
                if (!$carousel && ratio >= 0) {
                    $carousel = new EditorialCarousel({
                        carouselSelector: `#${carouselId} .carousel`,
                        groupCells: 3,
                    }).init();
                    $targetVideos.forEach(($video) => {
                        videoObserver.observe($video);
                    });
                    if (callback1) callback1($carousel);
                    observer.unobserve(entry.target);
                }
            }
        });
    }

    function handleVideoLoad(entries, observer) {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                if (entry.target.dataset) {
                    setSocialVideo({
                        bannerId: carouselId,
                        videoId: entry.target.id,
                        dtSrc: entry.target.dataset.src,
                        posterSrc: entry.target.dataset.poster,
                    });
                }
                observer.unobserve(entry.target);
            }
        });
    }

    const carouselObserver = new IntersectionObserver(handleCarouselInit, {
        root: null, // Use the viewport as the root
        threshold: [0],
    });

    const videoObserver = new IntersectionObserver(handleVideoLoad, {
        root: null,
        threshold: [0],
    });

    carouselObserver.observe($targetElement);
}

module.exports = observeCarousel;